import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { UserModel } from "app/_models/user-model";
import { AccountService } from "app/_services/account.service";
import { EncryptionService } from "app/_services/encryption.service";
declare const swal: any;

@Component({
  selector: "app-update-password",
  templateUrl: "./update-password.component.html",
  styleUrls: ["./update-password.component.css"],
})
export class UpdatePasswordComponent implements OnInit {
  updatePasswordForm: UntypedFormGroup;
  isLoaderResult: boolean = false;
  passwordIsValid = false;
  currentUser: UserModel;
  constructor(
    private readonly dialogRef: MatDialogRef<UpdatePasswordComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly encryptDecryptService: EncryptionService,
    private readonly accountService: AccountService
  ) {}

  ngOnInit(): void {
    this.initilizeForm();
  }
  initilizeForm() {
    this.updatePasswordForm = this.formBuilder.group({
      currentPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      confirmPassword: [null, [Validators.required]],
    });
  }

  updatePassword() {
    this.isLoaderResult = true;
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    let currentPassword = this.updatePasswordForm.value.currentPassword.trim();
    let newPassword =  this.updatePasswordForm.value.newPassword.trim();
    let confirmPassword = this.updatePasswordForm.value.confirmPassword.trim();
     
    if (newPassword != confirmPassword) {

      swal({
        title: "",
        text: "New password and Confirm Password values must be the same!",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      this.isLoaderResult = false;
    } else if (currentPassword == newPassword) {
     
      swal({
        title: "",
        text: "Current password and New Password values must not be the same!",
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      this.isLoaderResult = false;
    } else {
      // // this.encryptDecryptService.encrypt
      let model = {
        currentPassword: this.encryptDecryptService.encrypt(currentPassword),
        newPassword: this.encryptDecryptService.encrypt(newPassword),
        email: this.encryptDecryptService.encrypt(this.currentUser.userId),
      };
      this.accountService.updatePasswordV2(model).subscribe(
        (data) => {
          this.isLoaderResult = false;
          if (data.didError) {
            swal({
              title: "",
              text: data.message,
              type: "error",
              confirmButtonClass: "btn btn-info",
            });
          } else {
            swal({
              title: "",
              text: data.message,
              type: "success",
              confirmButtonClass: "btn btn-info",
            });
          }
          this.dialogRef.close();
        },
        (error) => {
          this.isLoaderResult = false;
          let errorMessage =
            error.error?.title ??
            error.error ??
            "Something went wrong. Please contact admin.";

          // Check if it's a validation error response with the `errors` object
          if (error.error?.errors) {
            const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
            if (allErrors.length > 0) {
              errorMessage = allErrors[0]; // Use the first validation message
            }
          } else if (typeof error.error === "string") {
            errorMessage = error.error;
          } else if (error.error?.title) {
            errorMessage = error.error.title;
          }
          this.dialogRef.close();
          swal({
            title: "",
            text: errorMessage,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        }
      );
    }
  }

  close() {
    this.dialogRef.close();
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }
}
